export interface PortfolioProject {
  id: string;
  name: string;
  client: string;
  year: string;
  medium: string;
  description: string;
  images: string[];
  tags: string[];
  featured?: boolean;
}

export const portfolioProjects: PortfolioProject[] = [
  {
    id: 'man-made-mondays',
    name: 'Man Made Mondays',
    client: 'Editorial Series',
    year: '2024',
    medium: 'Brand system / social art direction',
    description: 'A gritty campaign system built to stay recognizable across repeat weekly drops, social assets, and fast-turn print collateral.',
    images: ['/uploads/6961c5eec932d_manmademondays.webp'],
    tags: ['Campaign', 'Editorial', 'Social'],
    featured: false,
  },
  {
    id: 'sunstruck',
    name: 'Sunstruck',
    client: 'Hospitality Launch',
    year: '2024',
    medium: 'Launch identity / environmental graphics',
    description: 'A hospitality identity balancing nightlife heat with restraint, designed to translate from menus and signage into digital launch assets.',
    images: [
      '/uploads/6961ce6dbcd1e_sunstruck-3.webp',
      '/uploads/6961cde28da95_struck4.webp',
    ],
    tags: ['Hospitality', 'Launch', 'Identity'],
    featured: true,
  },
  {
    id: 'lobo-loco',
    name: 'Lobo Loco',
    client: 'Restaurant Campaign',
    year: '2024',
    medium: 'Campaign art / motion-ready assets',
    description: 'A loud restaurant campaign with poster energy, flexible enough for social teasers, in-store visuals, and event promotion.',
    images: [
      '/uploads/6961c40867606_lobolocosat1022.webp',
      '/uploads/6961c453611f7_lobolocosatelbrunch.webp',
    ],
    tags: ['Restaurant', 'Campaign', 'Events'],
    featured: true,
  },
  {
    id: 'tillies-at-sp2',
    name: 'Tillie\'s at SP2',
    client: 'Food + Beverage',
    year: '2024',
    medium: 'Art direction / launch storytelling',
    description: 'A warm identity system built around atmosphere and table-side detail, designed for quick campaign deployment.',
    images: ['/uploads/6961cf3c91865_tilliesatsp2bv1.webp'],
    tags: ['Food', 'Launch', 'Photography'],
    featured: false,
  },
  {
    id: 'refuge',
    name: 'REFUGE',
    client: 'Concept Identity',
    year: '2025',
    medium: 'Identity mark / concept frame',
    description: 'A sharper concept identity used here as a proof point for symbol-led branding, restraint, and atmosphere inside the portfolio system.',
    images: ['/refuge-logo.png'],
    tags: ['Identity', 'Concept', 'Mark'],
    featured: true,
  },
  {
    id: 'capone',
    name: 'Capone',
    client: 'Hospitality Brand',
    year: '2023',
    medium: 'Brand identity / menu design',
    description: 'A prohibition-era inspired identity with strong typographic hierarchy, vintage color, and a system that stretches across menus and social.',
    images: ['/uploads/69603595527cb_capone.jpg'],
    tags: ['Identity', 'Menus', 'Hospitality'],
    featured: true,
  },
  {
    id: 'carnivale',
    name: 'Carnivale',
    client: 'Event Campaign',
    year: '2023',
    medium: 'Campaign art direction / visual identity',
    description: 'A vibrant cultural festival campaign with bold color, dynamic typography, and a visual language built around momentum and celebration.',
    images: ['/uploads/695fe0b420dc7_carnivale.jpg'],
    tags: ['Event', 'Campaign', 'Identity'],
    featured: false,
  },
  {
    id: 'attic-fridays',
    name: 'Attic Fridays',
    client: 'Nightlife Series',
    year: '2024',
    medium: 'Social campaign / event branding',
    description: 'A weekly event series with evolving artwork held together by a consistent identity rhythm across promo drops and event touchpoints.',
    images: ['/uploads/695fd21461b88_atticfridays020.jpg'],
    tags: ['Nightlife', 'Series', 'Social'],
    featured: false,
  },
  {
    id: 'luciano',
    name: 'Luciano',
    client: 'Restaurant Identity',
    year: '2023',
    medium: 'Brand system / environmental design',
    description: 'An Italian restaurant identity balancing tradition with modernity through typography, warmth, and tactile visual texture.',
    images: ['/uploads/695fcf884f89a_luciano.jpg'],
    tags: ['Restaurant', 'Identity', 'Environmental'],
    featured: false,
  },
  {
    id: 'behind-cab',
    name: 'Behind Cab',
    client: 'Music Industry',
    year: '2023',
    medium: 'Album art / promotional materials',
    description: 'Album artwork and promotional design drawing from urban texture and industrial atmosphere for a sharper release campaign.',
    images: ['/uploads/696049dc05cb3_behindcab.jpeg'],
    tags: ['Music', 'Artwork', 'Campaign'],
    featured: false,
  },
];

export function findPortfolioProject(projectId: string) {
  return portfolioProjects.find((project) => project.id === projectId) ?? null;
}
